export default function ContactNumber(){
    return(
        <>
          <div className=" contact-section">
                  <h2 className="text-white">Om Sai PG Contact Number:- </h2>
                  <p className="text-white">
                    For booking inquiries or any assistance, please feel free to
                    contact us:
                  </p>
                  <p>
                    <strong className="text-white">Mobile No:</strong>{" "}
                    <a href="tel:+91 9763888448" className="text-white"> +91 9763888448 / </a>
                    <a href="tel:+919922248255" className="text-white">+91 9922248255</a>
                  </p>

                
                  <p className="text-white">
                    <strong>Email Id:</strong>{" "}
                    <a href="mailto:omsaipgpune@gmail.com" className="text-white">
                    omsaipgpune@gmail.com
                    </a>
                  </p>

                  <p className="text-white">
                    <strong>Address :- </strong>{" "}
                    <a href="" className="text-white">
                    Tulja Bhavani Nagar,Lane No 7, <br/>
                    Near Durga Mata Mandir,<br/>
                    Kharadi Pune - 411014
                    </a>
                  </p>
                </div>
        </>
    )
}